module.exports = __webpack_public_path__ + "img/usd.61d77f4f.svg";